import { Templates } from '@/types/common';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import type { Template } from '@/types/template';
import { getTemplateConfig } from '@/constants/templateConfig';

export const useTemplate = () => {
  const [searchParams] = useSearchParams();
  const templateType = searchParams.get('templateType') as Templates | null;

  const [template, setTemplate] = useState<Template>(getTemplateConfig(templateType ?? Templates.Default));

  return {
    template,
    setTemplate,
  };
};
